export default __webpack_public_path__ + "static/media/pl.0882b3e3.svg";